import images from './images'

export const Experiences = [
  {
    title: 'Box Custodia y Gestión Digital',
    job: 'Desarrollador Frontend',
    time: 'desde junio 2022 hasta la actualidad',
    img: images.boxcustodia_logo,
  },
  {
    title: 'Alkemy',
    job: 'Desarrollador Frontend',
    time: 'desde marzo 2021 a noviembre 2021',
    img: images.alkemy_logo,
  },
]
